import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: '首页', icon: 'ri-home-4-line' },
    { path: '/category/all', label: '分类浏览', icon: 'ri-apps-2-line' },
    { path: '/about', label: '关于我们', icon: 'ri-information-line' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <span className="text-2xl font-heading font-bold text-primary-500">
            韩漫网
          </span>
          <span className="hidden md:inline text-xs text-foreground-500 font-body border-l border-foreground-300 pl-2 ml-1">
            高质量韩国漫画在线阅读平台
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`relative text-sm font-label whitespace-nowrap cursor-pointer transition-colors duration-200 group ${
                location.pathname === link.path
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {link.label}
              <span
                className={`absolute -bottom-1 left-0 h-0.5 bg-primary-500 transition-all duration-200 ${
                  location.pathname === link.path ? 'w-full' : 'w-0 group-hover:w-full'
                }`}
              />
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="w-44 pl-9 pr-3 py-1.5 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-all duration-200"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          </div>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors ${
                location.pathname === link.path
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className={link.icon}></i>
              {link.label}
            </Link>
          ))}
          <div className="relative mt-2">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="w-full pl-9 pr-3 py-2 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          </div>
        </div>
      )}
    </nav>
  );
}